var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWhatsAppBlack = function SvgIconWhatsAppBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000C1A",
    clipPath: "url(#iconWhatsAppBlack_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.477 0 0 4.477 0 10c0 1.817.485 3.52 1.332 4.99L0 20l5.195-1.228A9.96 9.96 0 0 0 10 20c5.523 0 10-4.477 10-10S15.523 0 10 0m0 18.209c-1.671 0-3.226-.5-4.523-1.358l-3.069.782.86-2.934A8.209 8.209 0 1 1 10 18.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.343 11.32 2.42 1.14a.29.29 0 0 1 .172.288 2.46 2.46 0 0 1-.726 1.528c-1.615 1.615-4.514-.212-4.632-.283a8.7 8.7 0 0 1-2.033-1.537 8.7 8.7 0 0 1-1.538-2.033c-.07-.118-1.898-3.017-.283-4.632.572-.572 1.21-.7 1.528-.726a.29.29 0 0 1 .288.172l1.14 2.42a.3.3 0 0 1-.059.34l-.85.85a.59.59 0 0 0-.111.697c.31.557.727 1.093 1.21 1.586.494.483 1.03.9 1.586 1.21a.59.59 0 0 0 .698-.11l.85-.85a.3.3 0 0 1 .34-.06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconWhatsAppBlack_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconWhatsAppBlack;